const baseURL = "https://admtest.easycrypto.space/api/api.php";

async function request(action, method = "POST", data = {}, auth = true) {
  try {
    const headers = { "Content-Type": "application/json" };
    if (auth) {
      headers["Authorization"] = `Bearer ${localStorage.getItem(
        "ADMINMIXPAY__SERVICE__JWT"
      )}`;
    }

    const res = await fetch(baseURL, {
      method,
      headers,
      body: JSON.stringify({ action, ...data }),
    }).then((res) => res.json());

    return res;
  } catch (e) {
    console.error("API request error:", e);
  }
}

export const appAPI = {
  getUser: () => request("getuser"),
  auth: (data) => request("auth", "POST", data, false),
  getOrders: ({ page = 1, limit = 50, transaction_date_from, transaction_date_to, id }) => {
    return request("alloperations", "POST", { size: limit, page, transaction_date_from, transaction_date_to, id });
  },
  getUsers: (page = 1, limit = 50) =>
    request("allusers", "POST", { size: limit, page }),
  getSettings: () => request("allsettings"),
  saveSettings: (data) => request("savesettings", "POST", data),
  updateOrder: (data) => request("updateorder", "POST", data),
  editComment: (data) => request("editcomment", "POST", data),
  editRequisites: (data) => request("editrequisites", "POST", data),
  getComment: (data) => request("getcomment", "POST", data),
  getMediaFiles: (data) => request("getmediafiles", "POST", data),
};
